//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import SUB_BASIC_03 from './SUB_BASIC_03';
import { useNavigate } from 'react-router-dom';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import useDelete from '../../../../hooks/useDeleteN';
import useActionLog from '../../../../hooks/useActionLog';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import dayjs from 'dayjs';
import {
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch5,
  useSearch6,
  useSave1,
  useSave2,
  useSave3,
  useSave4,
  useDelete1,
  useDelete2,
  useDelete3,
} from './SUB_BASIC_03_QUERY';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import { toPreviewSrc, mapParamsBySchema } from '../../../../util';
import { SUB_BASIC_03_Schema } from './SUB_BASIC_03_Schema';
import { IsMeetingMinutesLocked } from './SUB_BASIC_03_ColumnDefs';
import { useSave } from '../../../../hooks/useSaveN';
import useFileUpload from '../../../../hooks/useFileUpload';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'SubcontractorManagement';

//#region 상수
const Inputs = {
  // 회의록 관련 필드
  chaebun: '', // 채번
  proceedingsDate: dayjs(), // 회의일시
  proceedingsStartTime: dayjs(), // 시작일시
  proceedingsEndTime: dayjs(), // 종료일시
  proceedingsLocation: '', // 회의장소
  proceedingsTitle: '', // 회의제목
  address: '', // 주소
  fileName: '', // 파일명
  saveName: '', // 저장명
  fcmToken: '', // FCM 토큰
};

//#endregion

function SUB_BASIC_03F(props) {
  //#region 변수
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const dispatch = useDispatch();

  //로그 관련
  const { SaveActionLog } = useActionLog();

  // 회의록 기본정보 그리드
  const [rowData1, setRowData1] = useState([]); // 회의록기본정보 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 회의록기본정보 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 회의록기본정보 그리드 변경 시 데이터
  const [deletedRowData1, setDeletedRowData1] = useState([]); // 회의록기본정보 그리드 삭제 시 데이터
  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const currentRowIndexRef = useRef(null);
  // 회의록 상세 조회(Search3) 시점의 회사측 참석자(id) 스냅샷
  // 회사측 참석자 삭제가 발생했는지 판단해, 저장 시 gubun='0'도 D3 삭제 후 재저장할지 결정
  const originalCompanyAttendeeIdsRef = useRef(new Set());
  const currentChaebunRef = useRef('');

  // 회의작성 등록팝업
  const [modalToggle2, setModalToggle2] = React.useState(false); // 회의록 팝업 창
  const [modalRowData2, setModalRowData2] = React.useState({}); // 회의록 팝업 데이터
  const [attendeeData, setAttendeeData] = React.useState([]); // 참석자 그리드 데이터

  // 회의작성 등록팝업안의 참석인원 추가하기 팝업
  const [modalToggle3, setModalToggle3] = React.useState(false); // 참석인원 추가 팝업 창
  const [modalRowData3, setModalRowData3] = React.useState([]); // 참석인원 추가 팝업 데이터
  const [selectedModalRowData3, setSelectedModalRowData3] = React.useState([]); // 참석인원 추가 팝업 ROW선택 데이터
  const [changedModalRowData3, setChangedModalRowData3] = React.useState([]); // 참석인원 추가 팝업 변경 데이터
  const [deletedModalRowData3, setDeletedModalRowData3] = React.useState([]); // 참석인원 추가 팝업 삭제 데이터

  const [searchKeyword, setSearchKeyword] = React.useState(''); // 검색 키워드
  const [searchResults, setSearchResults] = React.useState([]); // 검색 결과
  const [selectedWorkers, setSelectedWorkers] = React.useState([]); // 선택된 근로자들
  const [attendeeList, setAttendeeList] = React.useState([]); // 참석자 목록

  // 회의안건 관리 팝업
  const [modalToggle5, setModalToggle5] = React.useState(false); // 회의안건 관리 팝업 창
  const [meetingAgendaData, setMeetingAgendaData] = React.useState([]); // 회의안건 데이터
  // 수급업체 관련 상태
  const [subcontractorList, setSubcontractorList] = React.useState([]); // 수급업체 목록
  const [subcontractorAttendees, setSubcontractorAttendees] = React.useState(
    {}
  );
  //수급업체 선택 팝업
  const [modalToggle7, setModalToggle7] = React.useState(false);
  const [modalRowData7, setModalRowData7] = React.useState([]); // 수급업체 선택 팝업 데이터
  const [selectedModalRowData7, setSelectedModalRowData7] = React.useState([]); // 수급업체 선택 팝업 ROW선택 데이터

  const gridRef1 = useRef(); //회사정보 그리드
  const gridRef5 = useRef(); //회사정보 그리드
  const gridRef8 = useRef(); // 이전 회의 리스트 팝업 그리드
  const inputsRef = useRef(Inputs); //실제로 값이 변경 및 조회되는 회의록 폼 데이터

  const [inputs, setInputs] = useState(Inputs); // 진행사진데이터
  const imgRef2 = useRef(null); //진행사진
  const printRef = useRef([]); //참석자 명단 데이터

  //#region hooks
  // 메인 그리드 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(rows);
    },
  });

  // 회의록 상세 조회 (GetSubBasicMst03R3) - 회의 기본정보 및 참석자 정보 포함
  const { run: Search3 } = useSearch3({
    onSuccess: (rows) => {
      // rows는 배열 (회의 기본정보 + 참석자 정보가 각 행에 포함)
      if (!rows || rows.length === 0) {
        setAttendeeData([]);
        setSubcontractorAttendees({});
        setSubcontractorList([]);
        return;
      }

      // 첫 번째 행에서 회의 기본정보 추출
      const firstRow = rows[0];
      const masterData = {
        chaebun: firstRow.Chaebun || firstRow.chaebun || '',
        proceedingsTitle:
          firstRow.ProceedingsTitle || firstRow.proceedingsTitle || '',
        proceedingsDate:
          firstRow.ProceedingsDate || firstRow.proceedingsDate || '',
        proceedingsStartTime:
          firstRow.ProceedingsStartTime || firstRow.proceedingsStartTime || '',
        proceedingsEndTime:
          firstRow.ProceedingsEndTime || firstRow.proceedingsEndTime || '',
        proceedingsLocation:
          firstRow.ProceedingsLocation || firstRow.proceedingsLocation || '',
        proceedingsImage:
          firstRow.ProceedingsImage || firstRow.proceedingsImage || '',
        proceedingsImageNm:
          firstRow.ProceedingsImageNm || firstRow.proceedingsImageNm || '',
      };

      // 회의 기본정보 처리 (팝업이 열려있을 때만)
      if (modalToggle2) {
        // 회의 기본 정보 설정
        const chaebun = masterData.chaebun || '';
        setModalRowData2((prev) => ({
          ...prev,
          chaebun: chaebun || prev.chaebun,
          proceedingsTitle:
            masterData.proceedingsTitle || prev.proceedingsTitle,
          proceedingsDate: masterData.proceedingsDate
            ? dayjs(masterData.proceedingsDate).format('YYYY-MM-DD')
            : prev.proceedingsDate,
          proceedingsStartTime: (() => {
            const timeValue = masterData.proceedingsStartTime;
            if (!timeValue) return prev.proceedingsStartTime;

            // "0 15:15:00.000000" 형식을 "15:15"로 변환
            if (typeof timeValue === 'string') {
              const timeMatch = timeValue.match(/(\d{1,2}):(\d{2})/);
              if (timeMatch) {
                const hours = timeMatch[1].padStart(2, '0');
                const minutes = timeMatch[2];
                return dayjs(`${hours}:${minutes}`, 'HH:mm');
              }
            }

            // dayjs 객체인 경우
            if (dayjs.isDayjs(timeValue)) {
              return timeValue;
            }

            // dayjs로 파싱 시도
            const parsed = dayjs(timeValue, [
              'HH:mm',
              'HH:mm:ss',
              'HH:mm:ss.SSS',
            ]);
            return parsed.isValid() ? parsed : prev.proceedingsStartTime;
          })(),
          proceedingsEndTime: (() => {
            const timeValue = masterData.proceedingsEndTime;
            if (!timeValue) return prev.proceedingsEndTime;

            // "0 15:15:00.000000" 형식을 "15:15"로 변환
            if (typeof timeValue === 'string') {
              const timeMatch = timeValue.match(/(\d{1,2}):(\d{2})/);
              if (timeMatch) {
                const hours = timeMatch[1].padStart(2, '0');
                const minutes = timeMatch[2];
                return dayjs(`${hours}:${minutes}`, 'HH:mm');
              }
            }

            // dayjs 객체인 경우
            if (dayjs.isDayjs(timeValue)) {
              return timeValue;
            }

            // dayjs로 파싱 시도
            const parsed = dayjs(timeValue, [
              'HH:mm',
              'HH:mm:ss',
              'HH:mm:ss.SSS',
            ]);
            return parsed.isValid() ? parsed : prev.proceedingsEndTime;
          })(),
          proceedingsLocation:
            masterData.proceedingsLocation || prev.proceedingsLocation,
          meetingHost:
            masterData.meetingHost ||
            masterData.MeetingHost ||
            masterData.MEETING_HOST ||
            prev.meetingHost ||
            '',
          meetingCycle:
            masterData.meetingCycle ||
            masterData.MeetingCycle ||
            masterData.MEETING_CYCLE ||
            prev.meetingCycle ||
            '',
          totalWorkers: modalRowData3?.length || 0,
        }));
      }

      // 참석자 정보 처리 (모든 행에서 참석자 정보 추출)
      // Gubun(대소문자 혼재)이 있는 행만 참석자 정보로 처리
      const attendeeRows = rows.filter(
        (row) => row.gubun || row.Gubun || row.GUBUN
      );

      if (attendeeRows.length > 0) {
        const attendeeList = [];
        const subcontractorAttendeeMap = {};

        attendeeRows.forEach((item, index) => {
          const gubun = String(item.gubun ?? item.Gubun ?? item.GUBUN ?? '0');

          // patnerCompany 추출
          const patnerCompany =
            item.patnerCompany ||
            item.PatnerCompany ||
            item.PATNER_COMPANY ||
            item.patner_company ||
            '';

          // id 추출
          const id = item.id || item.ID || item.Id || '';

          const isSubcontractorAttendee = gubun === '1';

          if (isSubcontractorAttendee) {
            // 수급업체 참석자
            // 수급업체 "사업장" 키는 partnerCompany(PATNER_COMPANY)
            const subcontractorCustCd = patnerCompany || '';
            const custNm =
              item.custNm || item.CustNm || item.CUST_NM || item.CustNM || '';
            const key = subcontractorCustCd || custNm; // 없으면 최후의 fallback

            if (key) {
              if (!subcontractorAttendeeMap[key]) {
                subcontractorAttendeeMap[key] = [];
              }
              subcontractorAttendeeMap[key].push({
                id: `subcontractor_${subcontractorCustCd || key}_${index}_${Date.now()}`,
                name: item.name || item.NAME || item.Name || '',
                phone: item.tel || item.TEL || item.Tel || '',
                partnerRank:
                  item.partnerRank ||
                  item.PARTNER_RANK ||
                  item.PartnerRank ||
                  '',
                checkYn: item.checkYn || item.CHECK_YN || item.CheckYn || 'N',
                checkPath:
                  item.checkPath || item.CHECK_PATH || item.CheckPath || '',
                filePath:
                  item.filePath || item.FILE_PATH || item.FilePath || '',
                attendYn:
                  item.attendYn || item.ATTEND_YN || item.AttendYn || '',
                nonAttendReason:
                  item.nonAttendReason ||
                  item.NON_ATTEND_REASON ||
                  item.NonAttendReason ||
                  '',
                custCd: subcontractorCustCd || '', // 수급업체(사업장) 코드 = partnerCompany
                custNm: custNm || '', // 표시용
              });
            }
          } else {
            // 회사측 참석자 (gubun === '0'이고 id가 있거나 현 사업장인 경우)
            attendeeList.push({
              id: id,
              name: item.name || item.NAME || item.Name || '',
              tel: item.tel || item.TEL || item.Tel || '',
              partnerRank:
                item.partnerRank || item.PARTNER_RANK || item.PartnerRank || '',
              depNm: item.depNm || item.DEP_NM || item.DepNm || '',
              position: item.position || item.POSITION || item.Position || '',
              rank: item.rank || item.RANK || item.Rank || '',
              gubun: '0',
              checkYn: item.checkYn || item.CHECK_YN || item.CheckYn || 'N',
              checkPath:
                item.checkPath || item.CHECK_PATH || item.CheckPath || '',
              filePath: item.filePath || item.FILE_PATH || item.FilePath || '',
              attendYn: item.attendYn || item.ATTEND_YN || item.AttendYn || '',
              nonAttendReason:
                item.nonAttendReason ||
                item.NON_ATTEND_REASON ||
                item.NonAttendReason ||
                '',
            });
          }
        });

        setAttendeeData(attendeeList);
        // 회사측 참석자 삭제 감지를 위해 원본 id 목록 저장
        originalCompanyAttendeeIdsRef.current = new Set(
          (attendeeList || [])
            .map((a) => a?.id || a?.ID)
            .filter((v) => v != null && String(v).trim() !== '')
        );

        setSubcontractorAttendees(subcontractorAttendeeMap);

        // 수급업체 목록 생성 (사업장(custCd)별로 그룹화)
        // 현 사업장은 제외
        const currentCustCdForList = searchInfo?.custCd || '';
        const uniqueSubcontractors = {};
        Object.keys(subcontractorAttendeeMap).forEach((key) => {
          // 첫 번째 참석자에서 custCd 추출 (키가 custCd인 경우가 기본)
          const firstAttendee = subcontractorAttendeeMap[key][0];
          const scCustCd = firstAttendee?.custCd || key;

          // 현 사업장이면 수급업체 목록에서 제외
          if (scCustCd && scCustCd === currentCustCdForList) {
            return; // 현 사업장은 건너뜀
          }

          if (!uniqueSubcontractors[scCustCd]) {
            // 해당 사업장(custCd)에 맞는 수급업체 정보 찾기 (gubun 무관)
            const subcontractorInfo = attendeeRows.find((r) => {
              const rPatnerCompany =
                r.patnerCompany ||
                r.PatnerCompany ||
                r.PATNER_COMPANY ||
                r.patner_company ||
                '';
              // 수급업체 사업장 키는 partnerCompany로 매칭
              return rPatnerCompany === scCustCd;
            });
            uniqueSubcontractors[scCustCd] = {
              custCd: scCustCd,
              custNm:
                subcontractorInfo?.custNm ||
                subcontractorInfo?.CustNm ||
                subcontractorInfo?.CUST_NM ||
                subcontractorInfo?.CustNM ||
                firstAttendee?.custNm ||
                scCustCd ||
                '',
              ceo: subcontractorInfo?.ceo || subcontractorInfo?.CEO || '',
              ceoTel:
                subcontractorInfo?.ceoTel || subcontractorInfo?.CEO_TEL || '',
              attendeeCount: subcontractorAttendeeMap[key].length,
              attendedCount: subcontractorAttendeeMap[key].filter(
                (attendee) => attendee.attendYn === 'Y'
              ).length,
              notAttendedCount: subcontractorAttendeeMap[key].filter(
                (attendee) => attendee.attendYn === 'N'
              ).length,
            };
          }
        });

        setSubcontractorList(Object.values(uniqueSubcontractors));
      } else {
        setAttendeeData([]);
        setSubcontractorAttendees({});
        setSubcontractorList([]);
      }
    },
  });

  // 회의안건 조회
  const { run: Search2 } = useSearch2({
    onSuccess: async (data) => {
      if (data && data.length > 0) {
        const agendaList = data.map((item, index) => ({
          id: item.SEQ || item.seq || `temp-${Date.now()}-${index}`,
          chaebun: item.chaebun || '',
          SEQ: item.seq || '',
          agendaName: item.agendaName || '',
          resultDiscussion: item.resultDiscussion || '',
          editYn: 'N',
          state: item.state || '',
          newYn: 'N',
        }));

        setMeetingAgendaData(agendaList);

        // 회의작성 조회 시 채번 설정 (회의안건 저장 시 사용)
        const chaebunFromData = data[0]?.chaebun;
        if (chaebunFromData) {
          currentChaebunRef.current = chaebunFromData;
        }

        // 회의안건 팝업이 열려있을 때 사진 조회
        if (modalToggle5) {
          // selectedRowData1에서 파일 경로 가져오기
          const rowData = selectedRowData1?.[0];
          if (rowData) {
            // chaebun이 일치하는지 확인
            const rowChaebun = rowData.CHAEBUN || rowData.chaebun || '';
            if (
              rowChaebun === chaebunFromData ||
              rowChaebun === currentChaebunRef.current
            ) {
              const filePath =
                rowData.filePath ||
                rowData.FILE_PATH ||
                rowData.FilePath ||
                rowData.proceedingsImage ||
                rowData.PROCEEDINGS_IMAGE ||
                '';

              if (filePath) {
                // 파일 경로에서 이미지 URL 생성
                const imageUrl = `${Global.file.useUrl}files/${filePath}`;
                imgRef2.current = imageUrl;

                // inputsRef에도 파일 정보 설정
                const fileName = filePath.split('/').pop() || '';
                inputsRef.current = {
                  ...inputsRef.current,
                  fileName: fileName,
                  saveName: fileName,
                  filePath: filePath,
                };
              }
            }
          }
        }
      } else {
        setMeetingAgendaData([]);
      }
    },
  });

  // 참석인원추가하기 팝업- 참석인원 조회 함수
  // 외부인(internalYn='1')은 제외 — 우리 사업장 근로자만 선택
  const { run: Search5 } = useSearch5({
    onSuccess: (rows) => {
      const internalOnly = (rows || []).filter((row) => {
        const yn =
          row?.internalYn ?? row?.InternalYn ?? row?.INTERNAL_YN ?? '0';
        return yn !== 1 && yn !== '1' && yn !== true;
      });
      setModalRowData3(internalOnly);
    },
  });

  // 수급업체 목록 조회
  const { run: Search6 } = useSearch6({
    onSuccess: (rows) => {
      setModalRowData7(rows || []);
      setModalToggle7(true);
    },
  });

  // 저장 hooks
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();
  const { runAsync: Save3Async } = useSave3();
  const { runAsync: Save4Async } = useSave4();

  // 시간 값을 "HH:mm" 형식의 문자열로 변환하는 헬퍼 함수
  const formatTimeForSave = (timeValue) => {
    if (!timeValue) return '';

    // dayjs 객체인 경우
    if (dayjs.isDayjs(timeValue)) {
      return timeValue.format('HH:mm');
    }

    // 문자열인 경우 파싱 후 변환
    const timeStr = String(timeValue).trim();

    // 이미 "HH:mm" 형식인 경우
    if (/^\d{1,2}:\d{2}$/.test(timeStr)) {
      const parts = timeStr.split(':');
      const hours = parts[0].padStart(2, '0');
      const minutes = parts[1];
      return `${hours}:${minutes}`;
    }

    // "0 15:30:00.000000" 형태를 "15:30"로 변환
    const timeMatch = timeStr.match(/(\d{1,2}):(\d{2})/);
    if (timeMatch) {
      const hours = timeMatch[1].padStart(2, '0');
      const minutes = timeMatch[2];
      return `${hours}:${minutes}`;
    }

    // dayjs로 파싱 시도
    const parsed = dayjs(timeValue, ['HH:mm', 'HH:mm:ss', 'HH:mm:ss.SSS']);
    if (parsed.isValid()) {
      return parsed.format('HH:mm');
    }

    return '';
  };

  // 삭제 hooks (그리드 공통 삭제 로직: 삭제예정 표시/복원/실삭제)
  const delete1 = useDelete1();
  // 삭제 Handler
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  const { runAsync: Delete2Async } = useDelete2({
    userInfo,
  });

  const { runAsync: Delete3Async } = useDelete3();
  //#endregion

  const ResetLogic1 = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };

  // 기본정보 그리드 삭제 버튼: 선택행을 "삭제예정"으로 표시
  const DeleteLogic1 = () => {
    if (!selectedRowData1 || selectedRowData1.length === 0) {
      dispatch(
        showSnackbar({
          message: '삭제할 행을 선택하세요.',
          type: 'warning',
        })
      );
      return;
    }

    // 신규행은 아직 저장 전이므로, 저장/취소 흐름을 유지 (SAC_BASICF 패턴)
    const newRowExists = selectedRowData1.some((row) => row.newYn === 'Y');
    if (newRowExists) {
      dispatch(
        showSnackbar({
          message: '데이터 입력중입니다. 저장 후 시도하세요.',
          type: 'warning',
        })
      );
      return;
    }

    deleteHandler1.MarkedForDeletion(selectedRowData1);
  };

  useEffect(() => {
    if (!props.searchClick1) return;

    const custCd = searchInfo?.custCd || '';
    if (!custCd) return;

    ResetLogic1();
    Search1();
    props.setSearchClick1(false);
  }, [props.searchClick1, searchInfo?.custCd]);

  // 그리드 조회 함수 (기존 호환성 유지)
  const SearchLogic1 = async (_value1) => {
    ResetLogic1();
    await Search1();
  };
  //#endregion

  //#region 회의작성
  // 회의작성 수정 팝업 열기 함수
  const PopupClickEvent2Update = async (_data) => {
    // 그리드 데이터를 먼저 세팅
    const chaebun = _data.chaebun || _data.CHAEBUN || '';

    setModalRowData2({
      chaebun: chaebun,
      proceedingsTitle: _data.proceedingsTitle || _data.PROCEEDINGS_TITLE || '',
      proceedingsDate: _data.proceedingsDate
        ? dayjs(_data.proceedingsDate).format('YYYY-MM-DD')
        : _data.PROCEEDINGS_DATE
          ? dayjs(_data.PROCEEDINGS_DATE).format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
      proceedingsStartTime: (() => {
        const timeValue =
          _data.proceedingsStartTime || _data.PROCEEDINGS_START_TIME;
        if (!timeValue) return null;

        // "0 15:15:00.000000" 형식을 "15:15"로 변환
        if (typeof timeValue === 'string') {
          const timeMatch = timeValue.match(/(\d{1,2}):(\d{2})/);
          if (timeMatch) {
            const hours = timeMatch[1].padStart(2, '0');
            const minutes = timeMatch[2];
            return dayjs(`${hours}:${minutes}`, 'HH:mm');
          }
        }

        // dayjs 객체인 경우
        if (dayjs.isDayjs(timeValue)) {
          return timeValue;
        }

        // dayjs로 파싱 시도
        const parsed = dayjs(timeValue, ['HH:mm', 'HH:mm:ss', 'HH:mm:ss.SSS']);
        return parsed.isValid() ? parsed : null;
      })(),
      proceedingsEndTime: (() => {
        const timeValue =
          _data.proceedingsEndTime || _data.PROCEEDINGS_END_TIME;
        if (!timeValue) return null;

        // "0 15:15:00.000000" 형식을 "15:15"로 변환
        if (typeof timeValue === 'string') {
          const timeMatch = timeValue.match(/(\d{1,2}):(\d{2})/);
          if (timeMatch) {
            const hours = timeMatch[1].padStart(2, '0');
            const minutes = timeMatch[2];
            return dayjs(`${hours}:${minutes}`, 'HH:mm');
          }
        }

        // dayjs 객체인 경우
        if (dayjs.isDayjs(timeValue)) {
          return timeValue;
        }

        // dayjs로 파싱 시도
        const parsed = dayjs(timeValue, ['HH:mm', 'HH:mm:ss', 'HH:mm:ss.SSS']);
        return parsed.isValid() ? parsed : null;
      })(),
      proceedingsLocation:
        _data.proceedingsLocation || _data.PROCEEDINGS_LOCATION || '',
      meetingHost:
        _data.meetingHost || _data.MeetingHost || _data.MEETING_HOST || '',
      meetingCycle:
        _data.meetingCycle || _data.MeetingCycle || _data.MEETING_CYCLE || '',
      signRequestYn:
        _data.signRequestYn ||
        _data.SignRequestYn ||
        _data.SIGN_REQUEST_YN ||
        'N',
      minutesFileName: _data.minutesFileName || _data.MinutesFileName || '',
      minutesFileSaveName:
        _data.minutesFileSaveName || _data.MinutesFileSaveName || '',
      minutesFilePath: _data.minutesFilePath || _data.MinutesFilePath || '',
      minutesFile: null,
      minutesOldFilePath: '',
      totalWorkers: 0,
    });

    setModalToggle2(true);
    setAttendeeData([]); // 참석자 데이터 초기화
    setSubcontractorAttendees({}); // 수급업체 참석자 데이터 초기화
    setSubcontractorList([]); // 수급업체 목록 초기화

    dispatch(showLoading());

    try {
      // 참석자 정보 조회 (Search3의 onSuccess에서 처리됨)
      await Search3({
        search: {
          chaebun: chaebun,
          searchText: '',
        },
      });
      // 참석인원 추가 팝업용 조회
      await handleAttendeeSearch();
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: '데이터 조회 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };
  //#endregion

  //대표자 정보 조회 (결재요청시 대표자 정보 조회)
  //대표자 정보 조회 (결재요청시 대표자 정보 조회)
  const getCEOInfo = async (chaebun) => {
    try {
      const params = mapParamsBySchema(SUB_BASIC_03_Schema.mapper.search5);

      const result = await apiRequest(
        'post',
        Global.urls.SubcontractorManagement.getSubBasicMst03R4,
        params
      );

      if (result?.isSuccess && result?.data) {
        const data = Array.isArray(result.data) ? result.data : [result.data];
        if (data.length > 0) {
          // chaebun에 해당하는 대표자 정보 찾기
          const ceoInfo = data.find(
            (item) =>
              (item.CHAEBUN || item.chaebun || '') === chaebun &&
              (item.GUBUN || item.gubun) === '대표자'
          );
          return ceoInfo || data[0]; // 대표자 정보 1개 반환 (ID, FCM_TOKEN 등)
        }
      }
      return null;
    } catch (e) {
      dispatch(
        showSnackbar({
          message: '대표자 정보를 불러오는 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      return null;
    }
  };

  //#region 회의록 첨부파일
  const MINUTES_FILE_EXTS = [
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'hwp',
    'hwpx',
    'png',
    'jpg',
    'jpeg',
  ];

  const { DeleteLogicFile: DeleteLogicMinutesFile } = useFileUpload();

  // 회의록 첨부파일 선택 (저장 시 업로드)
  const ChangeMinutesFileLogic = (file) => {
    if (!file) return;

    const ext = file.name.split('.').pop()?.toLowerCase();
    if (!MINUTES_FILE_EXTS.includes(ext)) {
      dispatch(
        showSnackbar({
          message: `첨부할 수 없는 파일 형식입니다. (${MINUTES_FILE_EXTS.join(', ')})`,
          type: 'warning',
        })
      );
      return;
    }
    if (file.name.length > 100) {
      dispatch(
        showSnackbar({
          message:
            '파일명 길이가 100자를 초과합니다. 100자 이하로 파일명을 수정해 주세요.',
          type: 'warning',
        })
      );
      return;
    }

    setModalRowData2((prev) => ({
      ...prev,
      minutesFile: file,
      minutesFileName: file.name,
      minutesOldFilePath: prev.minutesOldFilePath || prev.minutesFilePath || '',
    }));
  };

  // 회의록 첨부파일 제거 (저장 시 반영)
  const RemoveMinutesFileLogic = () => {
    setModalRowData2((prev) => ({
      ...prev,
      minutesFile: null,
      minutesFileName: '',
      minutesFileSaveName: '',
      minutesOldFilePath: prev.minutesOldFilePath || prev.minutesFilePath || '',
      minutesFilePath: '',
    }));
  };

  // 회의록 첨부파일 파일서버 업로드
  const UploadMinutesFileLogic = async (file) => {
    const dirPath = `Business/${searchInfo.custCd}/SUB_BASIC_03/Minutes`;
    const saveName = `${dayjs().format('YYYYMMDDHHmmss')}_${file.name}`;
    const formList = new FormData();
    formList.append('UserId', userInfo.userid);
    formList.append('FilePath', dirPath);
    formList.append(
      'FormFile',
      new File([file], saveName, {
        type: file.type || 'application/octet-stream',
      })
    );

    const result = await Commons.Axios(
      'file',
      Global.file.useUrl + Global.urls.Execute.videoUpload,
      null,
      formList
    );
    const serverFilePath = result?.data?.filePath;
    if (!serverFilePath) return null;

    const savedName =
      serverFilePath.replace(/\\/g, '/').split('/').pop() || saveName;
    return { saveName: savedName, filePath: `${dirPath}/${savedName}` };
  };

  // 회의록 첨부파일 다운로드 (그리드/팝업 공용)
  const DownloadMinutesFileLogic = async (data) => {
    const pendingFile = data?.minutesFile;
    const fileName = data?.minutesFileName || data?.MinutesFileName || '';

    if (pendingFile instanceof File) {
      const url = window.URL.createObjectURL(pendingFile);
      const a = document.createElement('a');
      a.href = url;
      a.download = pendingFile.name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      return;
    }

    const filePath = data?.minutesFilePath || data?.MinutesFilePath || '';
    if (!filePath) {
      dispatch(
        showSnackbar({ message: '첨부된 파일이 없습니다.', type: 'warning' })
      );
      return;
    }

    const finalFileName = fileName || filePath.split('/').pop();
    try {
      dispatch(showLoading());
      const result = await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        { FileName: finalFileName, Url: Commons.EncodeUrl(filePath) }
      );

      if (!result?.data || !result?.headers?.['content-type']) {
        dispatch(
          showSnackbar({
            message: `"${finalFileName}" 다운로드 응답이 비정상입니다.`,
            type: 'error',
          })
        );
        return;
      }

      const blob = new Blob([result.data], {
        type: result.headers['content-type'],
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = finalFileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };
  //#endregion

  //#region 회의록 저장
  // 회의록 저장 (useSave 훅 사용)
  // 스키마 기반 필수 체크를 위해 fields.grid를 사용
  const saveSchema = {
    fields: SUB_BASIC_03_Schema.fields.grid,
  };

  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '회의제목, 회의날짜, 시작시간, 회의장소',
    schema: saveSchema,
    getChangedRows: () => {
      const saveRow = {
        chaebun: modalRowData2.chaebun || '',
        proceedingsDate: modalRowData2.proceedingsDate
          ? dayjs(modalRowData2.proceedingsDate).format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
        proceedingsStartTime: formatTimeForSave(
          modalRowData2.proceedingsStartTime
        ),
        proceedingsEndTime: formatTimeForSave(modalRowData2.proceedingsEndTime),
        proceedingsLocation: modalRowData2.proceedingsLocation || '',
        proceedingsTitle: modalRowData2.proceedingsTitle || '',
        meetingHost: modalRowData2.meetingHost || '',
        meetingCycle: modalRowData2.meetingCycle || '',
        state: '0', // 개최전
        minutesFileName: modalRowData2.minutesFileName || '',
        minutesFileSaveName: modalRowData2.minutesFile
          ? ''
          : modalRowData2.minutesFileSaveName || '',
        minutesFilePath: modalRowData2.minutesFile
          ? ''
          : modalRowData2.minutesFilePath || '',
      };

      return [saveRow];
    },
    fileSave: async (rows) => {
      const file = modalRowData2.minutesFile;
      if (!file) return;

      const uploaded = await UploadMinutesFileLogic(file);
      if (!uploaded) {
        throw new Error('회의록 첨부파일 업로드에 실패했습니다.');
      }
      rows.forEach((row) => {
        row.minutesFileName = file.name;
        row.minutesFileSaveName = uploaded.saveName;
        row.minutesFilePath = uploaded.filePath;
      });
    },
    requestSave: (rows) => Save1Async(rows),
    afterSaveRow: async (item, { index, savedRows, userInfo }) => {
      const saveResult = Array.isArray(savedRows) ? savedRows[index] : savedRows;
      if (saveResult?.isSuccess !== false) {
        const oldMinutesFilePath = modalRowData2.minutesOldFilePath || '';
        if (
          oldMinutesFilePath &&
          oldMinutesFilePath !== item?.minutesFilePath
        ) {
          await DeleteLogicMinutesFile(oldMinutesFilePath);
        }
        setModalRowData2((prev) => ({
          ...prev,
          minutesFile: null,
          minutesOldFilePath: '',
          minutesFileName: item?.minutesFileName || '',
          minutesFileSaveName: item?.minutesFileSaveName || '',
          minutesFilePath: item?.minutesFilePath || '',
        }));
      }

      const result = Array.isArray(savedRows) ? savedRows[index] : savedRows;

      let mstData = null;
      if (result) {
        if (Array.isArray(result)) {
          mstData = result;
        } else if (result.data) {
          mstData = Array.isArray(result.data) ? result.data : [result.data];
        } else {
          mstData = [result];
        }
      }

      if (!mstData || mstData.length === 0) {
        dispatch(
          showSnackbar({
            message: '저장 후 반환된 값이 없습니다.',
            type: 'error',
          })
        );
        return;
      }

      // 서버에서 반환된 Chaebun 추출
      const firstItem = mstData[0];

      const savedChaebun =
        firstItem?.Chaebun ||
        firstItem?.CHAEBUN ||
        firstItem?.chaebun ||
        result?.Chaebun ||
        result?.chaebun ||
        modalRowData2.chaebun;

      // 채번 업데이트
      currentChaebunRef.current = savedChaebun;
      setModalRowData2((prev) => ({
        ...prev,
        chaebun: savedChaebun,
      }));

      // SaveLogic2 호출 (참석자명단 저장)
      await SaveLogic2(savedChaebun);

      // 등록/수정 구분
      const isUpdate = modalRowData2.chaebun && modalRowData2.chaebun !== '';

      dispatch(
        showSnackbar({
          message: isUpdate ? '수정되었습니다.' : '등록되었습니다.',
          type: 'success',
        })
      );

      // 그리드 새로고침
      await Search1();
    },
    onError: async (error, rows) => {
      // 오류 시 로그
      await SaveActionLog([modalRowData2], {
        menuId: SCREEN_MENU_ID,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: 'ERROR',
        errorMsg: error?.message || '저장 중 오류가 발생했습니다.',
      });
    },
  });

  const SaveLogic1 = async () => {
    if (IsMeetingMinutesLocked(modalRowData2)) {
      dispatch(
        showSnackbar({
          message: '서명 요청 후에는 회의록을 수정할 수 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    // 회의제목, 회의날짜, 시작시간, 회의장소 입력 체크
    if (
      !modalRowData2.proceedingsTitle ||
      !modalRowData2.proceedingsDate ||
      !modalRowData2.proceedingsStartTime ||
      !modalRowData2.proceedingsLocation
    ) {
      dispatch(
        showSnackbar({
          message: '회의제목, 회의날짜, 시작시간, 회의장소를 입력해주세요.',
          type: 'warning',
        })
      );
      return;
    }
    // 참석자 체크
    if (!attendeeData || attendeeData.length === 0) {
      dispatch(
        showSnackbar({
          message: `참석자를 한명 이상 추가해주세요.`,
          type: 'warning',
        })
      );
      return;
    }
    // 회의안건 체크
    if (meetingAgendaData.length === 0) {
      dispatch(
        showSnackbar({
          message: '회의안건을 추가해주세요.',
          type: 'warning',
        })
      );
      return;
    }

    await Save1();

    // 사진만 변경되었는지 확인 (회의안건 데이터 변경 없이 사진만 업로드/삭제된 경우)
    const inputsRefCurrent = inputsRef?.current;
    const inputsState = inputs;
    const hasImageChange = !!(
      inputsRefCurrent?.mapFile ||
      inputsRefCurrent?.newYn === 'Y' ||
      inputsRefCurrent?.isImageDeleted ||
      inputsState?.mapFile ||
      inputsState?.newYn === 'Y' ||
      inputsState?.isImageDeleted
    );

    const changedAgendaRows = meetingAgendaData.filter(
      (item) => item.newYn === 'Y' || item.editYn === 'Y'
    );
    const hasAgendaChanges = changedAgendaRows.length > 0;

    if (hasImageChange && !hasAgendaChanges) {
      await save3();
      return;
    }

    const totalAgendaItems = meetingAgendaData.length;
    if (totalAgendaItems === 0) {
      dispatch(
        showSnackbar({
          message: '회의안건을 추가해주세요.',
          type: 'warning',
        })
      );
      return;
    }

    await save3();
  };

  //#region 회의록 참석자 저장
  // 참석자 저장 데이터 준비 함수
  const prepareAttendeeSaveData = (chaebun, attendees = null) => {
    const attendeesToSave = attendees || attendeeData;
    const allAttendeeSaveRows = [];
    // 아코디언(화면)에 추가된 수급업체(사업장)만 저장되도록 필터링
    // - subcontractorAttendees의 key는 custNm/custCd가 섞여 들어올 수 있어, subcontractorList 기준으로 허용 키를 만든다.
    const activeSubcontractorKeySet = new Set();
    if (Array.isArray(subcontractorList) && subcontractorList.length > 0) {
      subcontractorList.forEach((sc) => {
        const custCd = sc?.custCd;
        const custNm = sc?.custNm;
        const mixedKey = custNm || custCd;
        if (custCd) activeSubcontractorKeySet.add(custCd);
        if (custNm) activeSubcontractorKeySet.add(custNm);
        if (mixedKey) activeSubcontractorKeySet.add(mixedKey);
      });
    }

    const activeSubcontractorEntries =
      subcontractorAttendees &&
      Object.keys(subcontractorAttendees).length > 0 &&
      activeSubcontractorKeySet.size > 0
        ? Object.entries(subcontractorAttendees).filter(([key]) =>
            activeSubcontractorKeySet.has(key)
          )
        : [];

    // 서버 로직에 맞춰 저장:
    // - Gubun='0'이고 Id가 있으면 서버에서 중복 체크 후 INSERT/UPDATE
    // - Gubun='1'이면 항상 INSERT
    // - Seq는 서버에서 자동 생성 (MAX(SEQ) + 1)

    // 1. 회사측 참석자 저장 (GUBUN: '0')
    // 수급업체 참석자는 제외 (subcontractorAttendees에 포함된 참석자 제외)
    if (attendeesToSave && attendeesToSave.length > 0) {
      // 수급업체 참석자 목록 추출 (아코디언에 추가된 수급업체의 참석자만)
      const subcontractorAttendeeIds = new Set();
      if (activeSubcontractorEntries.length > 0) {
        activeSubcontractorEntries.forEach(([, attendees]) => {
          attendees?.forEach((attendee) => {
            // id가 있으면 id로, 없으면 name으로 구분
            const identifier = attendee?.id || attendee?.name;
            if (identifier) subcontractorAttendeeIds.add(identifier);
          });
        });
      }

      // 회사측 참석자만 필터링 (수급업체 참석자 제외)
      const companyAttendees = attendeesToSave.filter((attendee) => {
        // gubun이 '1'이면 수급업체 참석자이므로 제외
        if (attendee.gubun === '1') return false;
        // patnerCompany가 있으면 수급업체 참석자이므로 제외
        if (
          attendee.patnerCompany ||
          attendee.PatnerCompany ||
          attendee.PATNER_COMPANY
        ) {
          return false;
        }
        // subcontractorAttendees에 포함된 참석자 제외
        const identifier =
          attendee.id || attendee.ID || attendee.name || attendee.NAME;
        if (identifier && subcontractorAttendeeIds.has(identifier)) {
          return false;
        }
        return true;
      });

      if (companyAttendees.length > 0) {
        const attendeeSaveRows = companyAttendees.map((attendee) => ({
          chaebun: chaebun,
          gubun: '0',
          // seq는 서버에서 자동 생성되므로 전송하지 않음
          id: attendee.id || attendee.ID || '',
          name: attendee.name || attendee.NAME || '',
          tel: String(attendee.tel || attendee.TEL || '').replace(/\D/g, ''),
          patnerCompany: '', // 회사측 참석자는 patnerCompany 없음
          attendYn: attendee.attendYn || attendee.ATTEND_YN || '',
          checkYn: attendee.checkYn || attendee.CHECK_YN || 'N',
          checkPath: attendee.checkPath || attendee.CHECK_PATH || '',
        }));

        allAttendeeSaveRows.push(...attendeeSaveRows);
      }
    }

    // 2. 수급업체별 참석자 저장 (GUBUN: '1')
    if (activeSubcontractorEntries.length > 0) {
      activeSubcontractorEntries.forEach(([key, attendees]) => {
        if (!attendees || attendees.length === 0) return;

        // key는 custNm 또는 custCd (혼재 가능)
        // 참석자 데이터에서 custCd 추출 (참석자에 custCd가 있으면 우선 사용)
        const firstAttendee = attendees[0];
        let custCd = firstAttendee?.custCd;

        // 참석자에 custCd가 없으면 subcontractorList에서 찾기 (custNm/custCd 모두 매칭)
        if (!custCd) {
          const subcontractor = (subcontractorList || []).find((item) => {
            const itemCustCd = item?.custCd;
            const itemCustNm = item?.custNm;
            const itemKey = itemCustNm || itemCustCd;
            return itemCustCd === key || itemCustNm === key || itemKey === key;
          });
          custCd = subcontractor?.custCd || '';
        }

        const subcontractorAttendeeRows = attendees.map((attendee) => ({
          chaebun: chaebun,
          gubun: '1',
          // seq는 서버에서 자동 생성되므로 전송하지 않음
          id: `EXT_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`,
          name: attendee?.name || '',
          tel: String(attendee?.phone || '').replace(/\D/g, ''),
          patnerCompany: custCd || '', // 수급업체 코드
          partnerRank: attendee?.partnerRank || '', // 직위(역할) 구분
          attendYn: attendee?.attendYn || '',
          checkYn: attendee?.checkYn || 'N',
          checkPath: attendee?.checkPath || '',
        }));

        allAttendeeSaveRows.push(...subcontractorAttendeeRows);
      });
    }

    return allAttendeeSaveRows;
  };

  // 참석자 저장 함수
  const SaveLogic2 = async (chaebun, attendees = null) => {
    // chaebun 유효성 검사
    if (!chaebun || chaebun.trim() === '') {
      throw new Error('참석자 저장을 위한 채번이 없습니다.');
    }

    try {
      const allAttendeeSaveRows = prepareAttendeeSaveData(chaebun, attendees);

      // 참석자 삭제 후 저장:
      // - 수급업체(gubun='1')는 항상 "삭제(D3) 후 INSERT"로 처리
      // - 회사측(gubun='0')은 그리드에서 삭제가 발생한 경우에만 "삭제(D3) 후 재저장" 처리
      //   (서버 D3가 gubun 단위 삭제만 지원하므로, 개별 삭제 반영을 위해 전체 삭제 후 재저장 필요)
      try {
        const deleteRows = [{ chaebun, gubun: '1' }];

        const originalIds = originalCompanyAttendeeIdsRef.current || new Set();
        const currentIds = new Set(
          (attendees || attendeeData || [])
            .map((a) => a?.id || a?.ID)
            .filter((v) => v != null && String(v).trim() !== '')
        );
        const hasCompanyDeletion = Array.from(originalIds).some(
          (id) => !currentIds.has(id)
        );
        if (hasCompanyDeletion) {
          deleteRows.unshift({ chaebun, gubun: '0' });
        }

        await Delete3Async(deleteRows);
      } catch (deleteError) {}

      if (allAttendeeSaveRows.length > 0) {
        await Save2Async(allAttendeeSaveRows);
      }

      setModalToggle2(false);

      // 그리드 새로고침
      await Search1();
    } catch (e) {
      throw e; // 상위 함수에서 에러 처리하도록 전달
    }
  };

  //#endregion
  //#region 회의사진 저장
  //회의사진 저장(ftp 서버에업로드)
  const SaveLogic3 = async (_value1, _value2) => {
    try {
      let formList = new FormData();
      let filePath = `Business/${searchInfo.custCd}/SUB_BASIC_03`;

      // 원본 파일명이 있으면 File 객체의 name을 원본 파일명으로 변경
      let fileToUpload = _value1;
      if (_value2 && _value1 instanceof File) {
        // 원본 파일명으로 새로운 File 객체 생성
        fileToUpload = new File([_value1], _value2, {
          type: _value1.type,
          lastModified: _value1.lastModified,
        });
      }

      formList.append('UserId', userInfo.userid);
      formList.append('FilePath', filePath); // 저장경로(파일명 제외)
      formList.append('FormFile', fileToUpload); // 파일 (원본 파일명 사용)

      const result = await Commons.Axios(
        'file',
        Global.file.useUrl + Global.urls.Execute.videoUpload,
        null,
        formList
      );
      const data = result.data;

      if (data?.filePath) {
        // _value2(원본 파일명)가 있으면 사용, 없으면 서버에서 반환된 파일명 사용
        const serverFilePath = data.filePath.replace(/\\/g, '/');
        const fileName =
          _value2 ||
          serverFilePath.split('/').pop() ||
          serverFilePath.split('\\').pop();

        // 항상 Business/${searchInfo.custCd}/SUB_BASIC_03/fileName 형식으로 정규화
        const normalizedPath = `Business/${searchInfo.custCd}/SUB_BASIC_03/${fileName}`;

        return normalizedPath;
      } else {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }
    } catch (e) {
      dispatch(
        showSnackbar({
          message: '파일 업로드 중 오류 발생',
          type: 'error',
        })
      );
      return null;
    }
  };

  const handleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  //#endregion
  //#region 추가

  // 참석인원추가하기 팝업- 참석인원 조회 함수
  const handleAttendeeSearch = async () => {
    try {
      dispatch(showLoading());
      // 서버/Global 매칭: 참석자(근로자) 목록은 Member.getMemBasicR1 사용
      await Search5({
        userInfo,
        search: {
          custCd: searchInfo?.custCd || '',
          searchText: '',
        },
      });
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: '참석인원 조회 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      setModalRowData3([]);
    } finally {
      dispatch(closeLoading());
    }
  };

  // 이름 또는 사번으로 검색
  const handleSearchWorkers = async () => {
    try {
      dispatch(showLoading());
      await Search5({
        userInfo,
        search: {
          custCd: searchInfo?.custCd || '',
          searchText: searchKeyword || '',
        },
      });
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: '참석인원 조회 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      setModalRowData3([]);
    } finally {
      dispatch(closeLoading());
    }
  };

  //#endregion

  //#region 수급업체 관리
  // 수급업체 목록 조회 함수
  const handleSubcontractorSearch = async () => {
    await Search6({
      userInfo,
      search: {
        custCd: searchInfo?.custCd || '',
        searchText: '',
      },
    });
  };
  // 수급업체 선택 완료 함수
  const handleSubcontractorSelection = () => {
    if (selectedModalRowData7.length === 0) {
      dispatch(
        showSnackbar({ message: '수급업체를 선택해주세요.', type: 'warning' })
      );
      return;
    }

    // 이미 추가된 수급업체 목록 (custCd 기준)
    const existing = subcontractorList.map((item) => item.custCd);
    // 새롭게 추가할 수급업체만 필터링
    const newSubcontractors = selectedModalRowData7
      .filter((item) => !existing.includes(item.custCd))
      .map((subcontractor) => ({
        custCd: subcontractor.custCd,
        custNm: subcontractor.custNm,
        ceo: subcontractor.ceo || '',
        ceoTel: subcontractor.ceoTel || '',
        custManageRank: subcontractor.custManageRank || '', // 관리자직위
        custManageNm: subcontractor.custManageNm || '', // 관리자명
        custTel: subcontractor.custTel || '', // 관리자연락처
        attendeeCount: 0,
        attendedCount: 0,
        notAttendedCount: 0,
      }));

    if (newSubcontractors.length === 0) {
      dispatch(
        showSnackbar({
          message: '이미 선택된 수급업체는 제외되었습니다.',
          type: 'warning',
        })
      );
    }

    // 기존 목록에 새로운 수급업체 추가
    setSubcontractorList([...subcontractorList, ...newSubcontractors]);

    // 수급업체별 참석자 자동 추가 (대표자, 관리자)
    const newAttendees = {};
    newSubcontractors.forEach((subcontractor) => {
      const attendees = [];

      // 대표
      if (subcontractor.ceo && subcontractor.ceo.trim()) {
        attendees.push({
          id: `ceo_${subcontractor.custCd}_${Date.now()}`,
          name: subcontractor.ceo,
          phone: subcontractor.ceoTel || '',
          checkYn: 'N',
          checkPath: '',
          attendYn: '',
          nonAttendReason: '',
          partnerRank: '대표', // 직위(역할) 구분
          custCd: subcontractor.custCd, // custCd도 함께 저장
        });
      }

      // 관리자
      if (subcontractor.custManageNm && subcontractor.custManageNm.trim()) {
        attendees.push({
          id: `manager_${subcontractor.custCd}_${Date.now()}`,
          name: subcontractor.custManageNm,
          phone: subcontractor.custTel || '',
          checkYn: 'N',
          checkPath: '',
          attendYn: '',
          nonAttendReason: '',
          partnerRank: subcontractor.custManageRank, // 직위(역할) 구분
          custCd: subcontractor.custCd, // custCd도 함께 저장
        });
      }

      if (attendees.length > 0) {
        // 사업장별(custCd)로 키를 고정
        const key = subcontractor.custCd;
        if (key) newAttendees[key] = attendees;
      }
    });

    // 기존 참석자 데이터에 새로운 참석자 추가
    setSubcontractorAttendees((prev) => ({
      ...prev,
      ...newAttendees,
    }));

    // 팝업 닫기
    setModalToggle7(false);
    setSelectedModalRowData7([]);
  };

  // 수급업체 참석자 추가 함수
  const addSubcontractorAttendee = (subcontractorId) => {
    const newAttendee = {
      id: Date.now(),
      name: '',
      phone: '',
      checkYn: 'N',
      checkPath: '',
      attendYn: '',
      nonAttendReason: '',
      partnerRank: '',
    };

    setSubcontractorAttendees((prev) => ({
      ...prev,
      [subcontractorId]: [...(prev[subcontractorId] || []), newAttendee],
    }));
  };

  // 수급업체 참석자 삭제 함수
  const removeSubcontractorAttendee = (subcontractorId, attendeeId) => {
    // 참석자만 삭제하고, 사업장 키(patnerCompany=custCd)는 유지한다.
    // 사업장(아코디언) 삭제는 removeSubcontractor(헤더 X 버튼)로만 가능하도록 함.
    setSubcontractorAttendees((prev) => ({
      ...prev,
      [subcontractorId]:
        prev[subcontractorId]?.filter(
          (attendee) => attendee.id !== attendeeId
        ) || [],
    }));
  };

  // 수급업체 참석자 정보 업데이트 함수
  const updateSubcontractorAttendee = (
    subcontractorId,
    attendeeId,
    field,
    value
  ) => {
    setSubcontractorAttendees((prev) => ({
      ...prev,
      [subcontractorId]:
        prev[subcontractorId]?.map((attendee) =>
          attendee.id === attendeeId
            ? { ...attendee, [field]: value }
            : attendee
        ) || [],
    }));
  };

  // 수급업체 삭제 함수
  const removeSubcontractor = (subcontractorId) => {
    setSubcontractorList((prev) =>
      prev.filter((item) => item.custCd !== subcontractorId)
    );
    setSubcontractorAttendees((prev) => {
      const updated = { ...prev };
      delete updated[subcontractorId];
      return updated;
    });
  };

  //#region 회의안건
  // 회의안건 팝업 클릭 이벤트
  const PopupClickEvent5 = async (_data) => {
    const chaebun = _data.CHAEBUN || _data.chaebun || '';
    if (!chaebun) {
      dispatch(
        showSnackbar({
          message: '회의 정보를 불러올 수 없습니다.',
          type: 'error',
        })
      );
      return;
    }

    // 팝업 재오픈/다른 회의 선택 시 이전 데이터가 남지 않도록 초기화
    setMeetingAgendaData([]);

    // _data에서 파일 경로 가져오기
    const filePathFromData =
      _data.filePath ||
      _data.FILE_PATH ||
      _data.FilePath ||
      _data.proceedingsImage ||
      _data.PROCEEDINGS_IMAGE ||
      '';

    // 파일 경로가 없을 때만 이미지 리셋
    if (!filePathFromData) {
      imgRef2.current = null;
      inputsRef.current = Inputs;
    } else {
      // 파일 경로가 있으면 바로 이미지 로드 (재조회 시 사진 표시)
      const imageUrl = `${Global.file.useUrl}files/${filePathFromData}`;
      imgRef2.current = imageUrl;

      // inputsRef에 파일 정보 설정
      const fileName = filePathFromData.split('/').pop() || '';
      inputsRef.current = {
        ...Inputs,
        fileName: fileName,
        saveName: fileName,
        filePath: filePathFromData,
      };
    }

    setModalToggle5(true);
    dispatch(showLoading());

    // CHAEBUN 값을 상태로 저장
    currentChaebunRef.current = chaebun;

    try {
      // 회의안건 데이터 조회 (GetSubBasicMst03R2)
      await Search2({
        search: {
          chaebun: chaebun,
        },
      });

      // 이미지가 아직 로드되지 않았으면 selectedRowData1에서 시도
      if (!imgRef2.current) {
        const rowData = selectedRowData1?.[0];
        if (rowData) {
          // chaebun이 일치하는지 확인
          const rowChaebun = rowData.CHAEBUN || rowData.chaebun || '';
          if (rowChaebun === chaebun) {
            const filePath =
              rowData.filePath ||
              rowData.FILE_PATH ||
              rowData.FilePath ||
              rowData.proceedingsImage ||
              rowData.PROCEEDINGS_IMAGE ||
              '';

            if (filePath) {
              // 파일 경로에서 이미지 URL 생성
              const imageUrl = `${Global.file.useUrl}files/${filePath}`;
              imgRef2.current = imageUrl;

              // inputsRef에도 파일 정보 설정
              const fileName = filePath.split('/').pop() || '';
              inputsRef.current = {
                ...inputsRef.current,
                fileName: fileName,
                saveName: fileName,
                filePath: filePath,
              };
            }
          }
        }
      }
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };

  //#endregion
  // 회의안건 추가 함수
  const addMeetingAgenda = () => {
    const newItem = {
      id: Date.now(),
      AGENDA_NAME: '',
      RESULT_DISCUSSION: '',
      newYn: 'Y',
    };

    const updated = [...meetingAgendaData, newItem];
    setMeetingAgendaData(updated);

    // 그리드가 업데이트된 후 포커스 설정
    requestAnimationFrame(() => {
      const newRowIndex = updated.length - 1;
      if (gridRef5.current?.api) {
        // 먼저 행을 선택
        gridRef5.current.api.setFocusedCell(newRowIndex, 'AGENDA_NAME');
        // 그 다음 편집 모드 시작
        gridRef5.current.api.startEditingCell({
          rowIndex: newRowIndex,
          colKey: 'AGENDA_NAME',
        });
        // 행을 화면에 보이도록 스크롤
        gridRef5.current.api.ensureIndexVisible(newRowIndex);
      }
    });
  };

  // 회의안건 삭제 함수
  const deleteMeetingAgenda = (id) => {
    setMeetingAgendaData((prev) => {
      const item = prev.find((i) => i.id === id);

      if (!item) return prev;

      if (item.newYn === 'Y') {
        // 새로 추가된 행이면 완전 삭제
        return prev.filter((i) => i.id !== id);
      }

      // 기존 데이터면 deleteYn 토글
      return prev.map((i) => {
        if (i.id === id) {
          if (i.deleteYn === 'Y') {
            return { ...i, deleteYn: 'N' };
          }
          return { ...i, deleteYn: 'Y' };
        }
        return i;
      });
    });
  };

  // 회의안건 저장 (useSave 훅 사용)
  const { run: save3 } = useSave({
    menuId: SCREEN_MENU_ID,
    schema: {
      fields: SUB_BASIC_03_Schema.fields.agenda,
    },
    getChangedRows: () => {
      if (!currentChaebunRef.current) {
        dispatch(
          showSnackbar({
            message: '회의 채번이 없습니다. 회의 정보를 먼저 저장해주세요.',
            type: 'warning',
          })
        );
        return false;
      }

      const changedRows = meetingAgendaData.filter(
        (item) => item.newYn === 'Y' || item.editYn === 'Y'
      );
      const inputsRefCurrent = inputsRef?.current;
      // 사진이 삭제되었는지 확인 (isImageDeleted 플래그 또는 imgRef2가 null이고 기존 파일이 있었던 경우)
      const isImageDeleted =
        inputsRefCurrent?.isImageDeleted ||
        (!imgRef2.current &&
          (inputsRefCurrent?.filePath || inputsRefCurrent?.fileName));
      // mapFile이 있거나 newYn이 'Y'이면 사진이 변경된 것으로 간주
      const isImageUpdated = !!(
        inputsRefCurrent?.mapFile ||
        inputsRefCurrent?.newYn === 'Y' ||
        isImageDeleted
      );

      const saveRows = [];

      if (changedRows.length > 0) {
        // 이미지 미변경 시 기존 진행사진 경로 유지 (협의/세부만 수정 시 빈값으로 덮어쓰지 않도록)
        const agendaWithImage = meetingAgendaData.find(
          (a) => a.PROCEEDINGS_IMAGE || a.proceedingsImage
        );
        const existingImagePath =
          inputsRefCurrent?.filePath ||
          inputsRefCurrent?.FILE_PATH ||
          agendaWithImage?.PROCEEDINGS_IMAGE ||
          agendaWithImage?.proceedingsImage ||
          '';
        const existingImageNm =
          inputsRefCurrent?.saveName ||
          inputsRefCurrent?.fileName ||
          agendaWithImage?.PROCEEDINGS_IMAGE_NM ||
          agendaWithImage?.proceedingsImageNm ||
          '';

        changedRows.forEach((item) => {
          const chaebunValue =
            item.CHAEBUN || item.chaebun || currentChaebunRef.current;
          const itemImagePath =
            item.PROCEEDINGS_IMAGE ||
            item.proceedingsImage ||
            existingImagePath;
          const itemImageNm =
            item.PROCEEDINGS_IMAGE_NM ||
            item.proceedingsImageNm ||
            existingImageNm;
          saveRows.push({
            gubun: '0',
            chaebun: chaebunValue,
            seq: (item.SEQ || item.seq)?.toString() || '',
            agendaName: item.AGENDA_NAME || item.agendaName || '',
            resultDiscussion:
              item.RESULT_DISCUSSION || item.resultDiscussion || '',
            proceedingsImage: isImageUpdated ? '' : itemImagePath,
            proceedingsImageNm: isImageUpdated ? '' : itemImageNm,
            _isImageUpdated: isImageUpdated, // 파일 업로드 필요 여부
          });
        });
      }

      if (isImageUpdated && changedRows.length === 0) {
        saveRows.push({
          gubun: '1',
          chaebun: currentChaebunRef.current,
          seq: '',
          agendaName: '',
          resultDiscussion: '',
          proceedingsImage: '', // fileSave에서 설정됨
          proceedingsImageNm: '', // fileSave에서 설정됨
          _isImageUpdated: true,
          _isImageDeleted: isImageDeleted, // 사진 삭제 여부
        });
      }

      return saveRows;
    },
    getDeletedRows: () => {
      const deletedRows = meetingAgendaData.filter(
        (item) => item.deleteYn === 'Y'
      );
      return deletedRows.map((item) => ({
        chaebun: item.CHAEBUN || item.chaebun || currentChaebunRef.current,
        seq: (item.SEQ || item.seq)?.toString() || '',
        id: item.id, // UI에서 제거하기 위한 ID
      }));
    },
    requestDelete: (rows) => {
      // seq가 있는 항목만 삭제 요청
      const validRows = rows.filter((row) => row.seq && row.seq.trim() !== '');
      if (validRows.length === 0) return Promise.resolve([]);
      return Delete2Async(validRows);
    },
    fileSave: async (rows) => {
      // 파일 업로드 처리
      const inputsRefCurrent = inputsRef?.current;
      let imagePath = '';
      let imageFileName = '';

      // 사진이 삭제된 경우 빈값으로 설정
      const isImageDeleted = rows.some((row) => row._isImageDeleted);

      if (isImageDeleted) {
        // 사진 삭제된 경우 빈값으로 설정
        imagePath = '';
        imageFileName = '';
        // inputsRef도 초기화
        inputsRef.current = {
          ...inputsRef.current,
          filePath: '',
          fileName: '',
          saveName: '',
          mapFile: null,
          isImageDeleted: false, // 플래그 초기화
        };
      } else if (inputsRefCurrent?.mapFile) {
        const uploadedFilePath = await SaveLogic3(
          inputsRefCurrent.mapFile,
          inputsRefCurrent.fileName
        );
        if (!uploadedFilePath) {
          dispatch(
            showSnackbar({
              message: '파일 업로드 실패',
              type: 'error',
            })
          );
          throw new Error('파일 업로드 실패');
        }

        // SaveLogic3에서 이미 Business/{custCd}/SUB_BASIC_03/{filename} 형식으로 반환됨
        imagePath = uploadedFilePath;
        imageFileName = inputsRefCurrent?.fileName || '';
        inputsRef.current.filePath = uploadedFilePath;
        inputsRef.current.fileName = uploadedFilePath.split('/').pop() || '';
        inputsRef.current.isImageDeleted = false; // 플래그 초기화
      } else if (inputsRefCurrent?.fileName) {
        // 이미 업로드된 파일이 있는 경우
        // 파일명 추출 (전체 경로인 경우 마지막 부분만 사용)
        const fileName = inputsRefCurrent.saveName?.includes('/')
          ? inputsRefCurrent.saveName.split('/').pop()
          : inputsRefCurrent.saveName || inputsRefCurrent.fileName;

        // 항상 Business/${searchInfo.custCd}/SUB_BASIC_03/fileName 형식으로 정규화
        imagePath = `Business/${searchInfo.custCd}/SUB_BASIC_03/${fileName}`;
        imageFileName = inputsRefCurrent?.fileName || '';
      }

      // 파일 경로를 저장 데이터에 반영
      rows.forEach((row) => {
        if (row._isImageUpdated) {
          row.proceedingsImage = imagePath;
          row.proceedingsImageNm = imageFileName;
        }
        // _isImageUpdated, _isImageDeleted 제거 (서버로 전송하지 않음)
        delete row._isImageUpdated;
        delete row._isImageDeleted;
      });
    },
    requestSave: (rows) => Save3Async(rows),
    afterDeleteRow: async (item, { index, deletedRows, userInfo }) => {
      // 삭제 성공 시 UI에서 제거
      if (item.id) {
        setMeetingAgendaData((prev) =>
          prev.filter((agenda) => agenda.id !== item.id)
        );
      }
    },
    afterSaveRow: async (item, { index, savedRows, userInfo }) => {
      // 저장된 파일 경로 가져오기
      // 우선순위: inputsRef.current.filePath > item > savedRows
      const savedFilePath =
        inputsRef.current?.filePath ||
        item?.proceedingsImage ||
        item?.PROCEEDINGS_IMAGE ||
        savedRows?.[index]?.proceedingsImage ||
        savedRows?.[index]?.PROCEEDINGS_IMAGE ||
        savedRows?.[0]?.proceedingsImage ||
        savedRows?.[0]?.PROCEEDINGS_IMAGE ||
        '';

      // 팝업 재조회 (저장된 파일 경로 전달)
      await PopupClickEvent5({
        CHAEBUN: currentChaebunRef.current,
        filePath: savedFilePath,
        FILE_PATH: savedFilePath,
        proceedingsImage: savedFilePath,
        PROCEEDINGS_IMAGE: savedFilePath,
      });
      await Search1();
    },
  });

  //#endregion

  //#region 회의 개최
  // 회의 개최 저장을 위한 상태 관리
  const meetingStartParamsRef = useRef({ type: null, meetingData: null });

  // 회의 개최 저장 (useSave 훅 사용)
  const { run: save4 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '채번',
    schema: {
      fields: {
        chaebun: { initial: '', label: '채번', required: 'Y' },
        state: { initial: '1', label: '상태' },
      },
    },
    getChangedRows: () => {
      const { type, meetingData } = meetingStartParamsRef.current;
      return [
        {
          chaebun: meetingData?.CHAEBUN || meetingData?.chaebun || '',
          state: type || '1',
        },
      ];
    },
    requestSave: (rows) => Save4Async(rows),
    afterSaveRow: async (item, { index, savedRows, userInfo }) => {
      // 성공시 그리드 새로고침
      await Search1();

      dispatch(
        showSnackbar({
          message: '회의가 개최되었습니다.',
          type: 'success',
        })
      );
    },
  });

  // 회의 개최 함수 (기존 호출 방식 유지)
  const handleMeetingStart = async (type, meetingData) => {
    // 파라미터를 ref에 저장
    meetingStartParamsRef.current = { type, meetingData };
    // useSave 훅의 run 함수 호출
    await save4();
  };
  //#endregion

  //#region 참석자 알림요청
  // 참석자 알림요청 (알림보내기 전에 참석자 조회 후 ID 와 FCM_TOKEN 값으로 알림보냄)
  // 참석자 정보는 GetSubBasicMst03R3 (회의록 상세 조회)에서 가져옴
  const AlarmResponseData = async (chaebun) => {
    try {
      const params = mapParamsBySchema(SUB_BASIC_03_Schema.mapper.search3, {
        search: {
          chaebun: chaebun || '',
          searchText: '',
        },
      });

      const result = await apiRequest(
        'post',
        Global.urls.SubcontractorManagement.getSubBasicMst03R3,
        params
      );

      if (result?.isSuccess && result?.data) {
        const data = Array.isArray(result.data) ? result.data : [result.data];
        if (!data || data.length === 0) {
          return {
            attendeeList: [],
          };
        }

        // 참석자 정보만 필터링 (gubun이 있는 행만 참석자 정보)
        const attendeeRows = data.filter(
          (row) => row.gubun || row.GUBUN || row.Gubun
        );
        printRef.current = attendeeRows; //참석자 명단 데이터

        if (!attendeeRows || attendeeRows.length === 0) {
          return {
            attendeeList: [],
          };
        }

        const attendeeList = [];

        attendeeRows.forEach((item) => {
          const fcmToken =
            item.FCM_TOKEN || item.fcmToken || item.FcmToken || '';
          const id = item.ID || item.id || '';
          const name = item.NAME || item.name || '';
          const tel = item.TEL || item.tel || item.Tel || '';
          const gubun = String(item.gubun || item.GUBUN || item.Gubun || '');

          attendeeList.push({
            FCM_TOKEN: fcmToken,
            ID: id,
            NAME: name,
            TEL: tel,
            IS_EXTERNAL: gubun === '1' || String(id).trim().startsWith('EXT_'),
          });
        });

        return {
          attendeeList,
        };
      }

      return {
        attendeeList: [],
      };
    } catch (e) {
      dispatch(
        showSnackbar({
          message: '참석자 정보를 불러오는 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      return {
        attendeeList: [],
      };
    }
  };

  const HasValidFcmToken = (token) =>
    token &&
    token.trim() !== '' &&
    token !== '0' &&
    token !== 'null' &&
    token !== 'undefined';

  const ParseNotificationBatchResponse = (result, fallbackError) => {
    let data = result?.data;
    let responseData = null;

    if (Array.isArray(data) && data.length > 0) {
      responseData = data[0];
    } else if (data && typeof data === 'object' && !Array.isArray(data)) {
      responseData = data;
    }

    if (responseData) {
      const isSuccess =
        responseData.isSuccess !== undefined
          ? responseData.isSuccess
          : responseData.IsSuccess;

      if (
        isSuccess === false ||
        responseData.type === 'Error' ||
        responseData.Type === 'Error'
      ) {
        return {
          success: false,
          error: responseData.message || responseData.Message || fallbackError,
        };
      }
      if (isSuccess === true) {
        return { success: true };
      }
      if (responseData.StatusType && responseData.StatusType !== 'ERROR') {
        return { success: true };
      }
    }

    if (
      Array.isArray(data) &&
      data.length > 0 &&
      (data[0].type === 'Error' || data[0].Type === 'Error')
    ) {
      return {
        success: false,
        error: data[0].message || data[0].Message || fallbackError,
      };
    }

    if (data === 'Fail' || responseData === 'Fail') {
      return {
        success: false,
        error: '사용자가 어플에 로그인하지 않았습니다.',
      };
    }

    return { success: false, error: '알 수 없는 응답' };
  };

  // 참석자 서명 알림요청 (_value1 : "0", _value2:"선택된 행 데이터")
  const SignRequest = async (_value1, _value2) => {
    const chaebun = _value2?.chaebun;
    const { attendeeList } = await AlarmResponseData(chaebun);

    if (_value1 === '0') {
      if (!attendeeList || attendeeList.length === 0) {
        dispatch(
          showSnackbar({
            message: '참석자 명단 추가 후 진행하세요.',
            type: 'warning',
          })
        );
        return;
      }

      const internalAttendees = attendeeList.filter((a) => !a.IS_EXTERNAL);
      const externalAttendees = attendeeList.filter((a) => a.IS_EXTERNAL);

      const validFcmAttendees = internalAttendees.filter((attendee) =>
        HasValidFcmToken(attendee.FCM_TOKEN)
      );
      const validExternalAttendees = externalAttendees.filter(
        (attendee) => attendee.TEL && String(attendee.TEL).trim() !== ''
      );

      const invalidInternalCount =
        internalAttendees.length - validFcmAttendees.length;
      const invalidExternalCount =
        externalAttendees.length - validExternalAttendees.length;

      const alimtalkUrl = Global.base.useUrl + Global.urls.Alimtalk.signRequest;

      const fcmResultsPromise = Promise.allSettled(
        validFcmAttendees.map(async (item) => {
          try {
            const payload = [
              {
                ResponseId: Commons.EncryptAES(item.ID),
                RequestId: Commons.EncryptAES(userInfo.userid),
                Title: Commons.EncryptAES('도급사업 안전보건 협의체 회의록'),
                Body: Commons.EncryptAES(
                  '안전보건 협의체 회의 서명 요청입니다.'
                ),
                Route: Commons.EncryptAES(`/M_Meeting/detail/C${chaebun}`),
                ResponseData: Commons.EncryptAES(chaebun),
                Gubun: Commons.EncryptAES('AL_001_005'),
                FcmToken: item.FCM_TOKEN || '',
              },
            ];
            const fcmUrl = Global.base.useUrl + Global.urls.FCM.fcm;
            const result = await Commons.Axios('post', fcmUrl, payload);
            const parsed = ParseNotificationBatchResponse(
              result,
              '알림 전송 실패'
            );
            return { ...parsed, name: item.NAME, channel: 'fcm' };
          } catch (error) {
            return {
              success: false,
              error: error.message,
              name: item.NAME,
              channel: 'fcm',
            };
          }
        })
      );

      const alimtalkResultsPromise = Promise.allSettled(
        validExternalAttendees.map(async (item) => {
          try {
            const telDigits = String(item.TEL || '').replace(/\D/g, '');
            const payload = [
              {
                RecipientNo: Commons.EncryptAES(telDigits),
                Name: Commons.EncryptAES(item.NAME || ''),
                Type: Commons.EncryptAES('도급사업 안전보건 협의체'),
                Id: Commons.EncryptAES(`C${chaebun}` || ''),
                Tel: Commons.EncryptAES(telDigits),
              },
            ];
            const result = await Commons.Axios('post', alimtalkUrl, payload);
            const parsed = ParseNotificationBatchResponse(
              result,
              '알림톡 전송 실패'
            );
            return { ...parsed, name: item.NAME, channel: 'alimtalk' };
          } catch (error) {
            return {
              success: false,
              error: error.message,
              name: item.NAME,
              channel: 'alimtalk',
            };
          }
        })
      );

      const [fcmResults, alimtalkResults] = await Promise.all([
        fcmResultsPromise,
        alimtalkResultsPromise,
      ]);

      const allResults = [...fcmResults, ...alimtalkResults];
      const allAttendees = [...validFcmAttendees, ...validExternalAttendees];

      const successResults = [];
      const failResults = [];
      const errorResults = [];

      allResults.forEach((result, index) => {
        if (result.status === 'fulfilled') {
          if (result.value.success) {
            successResults.push(result.value);
          } else {
            failResults.push(result.value);
          }
        } else {
          errorResults.push({
            name: allAttendees[index]?.NAME || '알 수 없음',
            error: result.reason?.message || '알 수 없는 오류',
          });
        }
      });

      const successCount = successResults.length;
      const failCount = failResults.length;
      const errorCount = errorResults.length;
      // 통합된 결과 메시지 생성
      let message = '';
      let messageType = 'info';

      if (successCount > 0) {
        const successNames = successResults.map((r) => r.name).join(', ');
        message += `${successCount}명에게 서명 요청 전송 완료: ${successNames}`;
        message +=
          '\n서명 요청 후에는 회의록을 수정할 수 없습니다. (조회만 가능)';
        messageType = 'success';
      }

      if (failCount > 0) {
        const failNames = failResults.map((r) => r.name).join(', ');
        if (message) message += '\n';
        message += `${failCount}명 전송 실패: ${failNames}`;
        if (messageType === 'success') messageType = 'warning';
      }

      if (errorCount > 0) {
        const errorNames = errorResults.map((r) => r.name).join(', ');
        if (message) message += '\n';
        message += `${errorCount}명 전송 중 오류 발생: ${errorNames}`;
        messageType = 'error';
      }

      if (invalidInternalCount > 0) {
        if (message) message += '\n';
        message += `${invalidInternalCount}명은 앱 알림을 받을 수 없습니다. (앱 미설치 또는 로그인 안됨)`;
        if (messageType === 'success') messageType = 'info';
      }

      if (invalidExternalCount > 0) {
        if (message) message += '\n';
        message += `${invalidExternalCount}명은 알림톡을 받을 수 없습니다. (전화번호 미입력)`;
        if (messageType === 'success') messageType = 'info';
      }

      // 통합된 메시지 표시
      if (message) {
        dispatch(
          showSnackbar({
            message: message,
            type: messageType,
          })
        );
      }

      // 서명요청 성공 시 회의록 수정 잠금 플래그 저장
      if (successCount > 0 && chaebun) {
        try {
          await Save4Async([
            {
              chaebun,
              state: '',
              signRequestYn: 'Y',
            },
          ]);
          await Search1();
        } catch (e) {
          console.log(e);
        }
      }
    } else {
      // 대표자 결재요청 로직
      const chaebun =
        selectedRowData1[0].CHAEBUN || selectedRowData1[0].chaebun;

      try {
        // 대표자 정보 조회
        const ceoInfo = await getCEOInfo(chaebun);

        // FCM 토큰 유효성 검사
        if (
          !ceoInfo ||
          !ceoInfo.FCM_TOKEN ||
          ceoInfo.FCM_TOKEN.trim() === '' ||
          ceoInfo.FCM_TOKEN === '0' ||
          ceoInfo.FCM_TOKEN === 'null' ||
          ceoInfo.FCM_TOKEN === 'undefined'
        ) {
          dispatch(
            showSnackbar({
              message:
                '대표자 정보를 찾을 수 없거나 알림을 받을 수 없습니다. (앱 미설치 또는 로그인 안됨)',
              type: 'warning',
            })
          );
          return;
        }

        // FCM 전송
        const result = await Commons.Axios(
          'post',
          Global.base.useUrl + Global.urls.FCM.fcm,
          [
            {
              ResponseId: Commons.EncryptAES(
                ceoInfo.CO_ID || ceoInfo.custCd || ''
              ),
              RequestId: Commons.EncryptAES(userInfo.userid),
              Title: Commons.EncryptAES('도급사업 안전보건 협의체 회의록'),
              Body: Commons.EncryptAES('대표자 사인요청입니다.'),
              Route: Commons.EncryptAES(`/M_Meeting/detail/C${chaebun}`),
              ResponseData: Commons.EncryptAES(chaebun),
              Gubun: Commons.EncryptAES('AL_001_006'),
              FcmToken: ceoInfo.FCM_TOKEN || ceoInfo.fcmToken || '',
            },
          ]
        );

        // 서버 응답 처리: BuildBatchResponse 형식 또는 배열 형식 모두 처리
        const data = result.data;
        let responseData = null;

        // 배열인 경우 첫 번째 요소 사용
        if (Array.isArray(data) && data.length > 0) {
          responseData = data[0];
        } else if (data && typeof data === 'object') {
          // 객체인 경우 그대로 사용
          responseData = data;
        }

        if (responseData) {
          // BuildBatchResponse 형식 체크 (isSuccess, StatusType, Message)
          if (
            responseData.isSuccess === false ||
            responseData.type === 'Error'
          ) {
            dispatch(
              showSnackbar({
                message:
                  responseData.message ||
                  responseData.Message ||
                  '결재요청 전송 중 오류가 발생했습니다.',
                type: 'error',
              })
            );
            return;
          } else if (responseData.isSuccess === true) {
            dispatch(
              showSnackbar({
                message: '1건의 결재요청이 완료되었습니다.',
                type: 'success',
              })
            );
            return;
          }
        }

        // 배열이면서 Error 타입인 경우
        if (
          Array.isArray(data) &&
          data.length > 0 &&
          data[0].type === 'Error'
        ) {
          dispatch(
            showSnackbar({
              message:
                data[0].message || '결재요청 전송 중 오류가 발생했습니다.',
              type: 'error',
            })
          );
          return;
        }

        // Fail 문자열 체크
        if (data === 'Fail' || responseData === 'Fail') {
          dispatch(
            showSnackbar({
              message: '대표자가 어플에 로그인하지 않았습니다.',
              type: 'warning',
            })
          );
          return;
        }

        // 알 수 없는 응답
        dispatch(
          showSnackbar({
            message: '결재요청 전송 중 오류가 발생했습니다.',
            type: 'error',
          })
        );
      } catch (error) {
        dispatch(
          showSnackbar({
            message: '결재요청 전송 중 오류가 발생했습니다.',
            type: 'error',
          })
        );
      }
    }
  };

  //#endregion
  //#region 진행사진 가져오기
  //사진 가져오기
  const SearchPhoto = (_filePath) => {
    imgRef2.current = toPreviewSrc(_filePath);
  };

  //#region 인쇄 함수
  //인쇄 함수
  const PrintLogic3 = async (_value1) => {
    // SUB_BASIC_02F.PrintLogic1 구조에 맞춤:
    // 1) 선택값 체크  2) 조회/가공(빈 데이터/에러 처리)  3) report 호출(blob open)
    if (!selectedRowData1?.[0]) {
      dispatch(
        showSnackbar({
          message: '인쇄할 항목을 선택하세요.',
          type: 'warning',
        })
      );
      return;
    }

    dispatch(showLoading());

    try {
      const selectedMeeting = selectedRowData1[0];
      const chaebun = selectedMeeting.CHAEBUN || selectedMeeting.chaebun || '';

      if (!chaebun) {
        dispatch(
          showSnackbar({
            message: '인쇄할 데이터를 불러올 수 없습니다.',
            type: 'error',
          })
        );
        return;
      }

      // 사업장명(custNm) - SUB_BASIC_02F 패턴
      const custNm =
        searchInfo?.custList?.find((item) => item.value === searchInfo?.custCd)
          ?.name || '';

      // 날짜/시간 포맷
      const proceedingsDateRaw =
        selectedMeeting.PROCEEDINGS_DATE ||
        selectedMeeting.proceedingsDate ||
        '';
      const proceedingsDate = proceedingsDateRaw
        ? dayjs(proceedingsDateRaw).format('YYYY-MM-DD')
        : '';
      const startTimeRaw =
        selectedMeeting.PROCEEDINGS_START_TIME ||
        selectedMeeting.proceedingsStartTime ||
        '';
      const endTimeRaw =
        selectedMeeting.PROCEEDINGS_END_TIME ||
        selectedMeeting.proceedingsEndTime ||
        '';

      const safeTime = (v) => {
        if (!v) return '';
        if (typeof v === 'string' && /^\d{2}:\d{2}$/.test(v)) return v;
        const parsed = dayjs(v);
        return parsed.isValid() ? parsed.format('HH:mm') : '';
      };

      const startTime = safeTime(startTimeRaw);
      const endTime = safeTime(endTimeRaw);
      const proceedingsDateTime = `${proceedingsDate}${
        startTime ? ` ${startTime}${endTime ? ` ~ ${endTime}` : ''}` : ''
      }`;

      // 회의사진(base64) 조회 (실패해도 계속 진행)
      imgRef2.current = null;
      const proceedingsImage =
        selectedMeeting.PROCEEDINGS_IMAGE ||
        selectedMeeting.proceedingsImage ||
        '';
      const proceedingsImageNm =
        selectedMeeting.PROCEEDINGS_IMAGE_NM ||
        selectedMeeting.proceedingsImageNm ||
        '';
      if (proceedingsImage) {
        try {
          SearchPhoto(proceedingsImage);
        } catch (e) {}
      }

      // 1) headerData
      const headerData = [
        {
          proceedingsTitle:
            selectedMeeting.PROCEEDINGS_TITLE ||
            selectedMeeting.proceedingsTitle ||
            '',
          proceedingsDateTime,
          proceedingsLocation:
            selectedMeeting.PROCEEDINGS_LOCATION ||
            selectedMeeting.proceedingsLocation ||
            '',
          state: selectedMeeting.STATE || selectedMeeting.state || '',
          custNm,
          month: dayjs().format('MM'),
          proceedingsImage,
          proceedingsImageNm,
          meetingPhoto: imgRef2.current
            ? String(imgRef2.current).replace(/^data:image\/[a-z]+;base64,/, '')
            : '',
          meetingHost: selectedMeeting.meetingHost || '',
          meetingCycle: selectedMeeting.meetingCycle || '',
        },
      ];

      // 2) 참석자/수급업체 참석자 데이터: GetSubBasicMst03R3에서 gubun 포함 행만 추출
      const search3Params = mapParamsBySchema(
        SUB_BASIC_03_Schema.mapper.search3,
        {
          search: { chaebun, searchText: '' },
        }
      );
      const search3Result = await apiRequest(
        'post',
        Global.urls.SubcontractorManagement.getSubBasicMst03R3,
        search3Params
      );

      const detailRowsRaw = search3Result?.data;
      const detailRows = Array.isArray(detailRowsRaw)
        ? detailRowsRaw
        : detailRowsRaw
          ? [detailRowsRaw]
          : [];

      if (!detailRows.length || detailRows[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: detailRows[0]?.message || '인쇄할 데이터가 없습니다.',
            type: 'error',
          })
        );
        return;
      }

      const attendeeRows = detailRows.filter(
        (r) => r?.gubun || r?.GUBUN || r?.Gubun
      );
      const list0 = attendeeRows.filter(
        (r) => String(r?.gubun ?? r?.GUBUN ?? r?.Gubun ?? '') === '0'
      );
      const list1 = attendeeRows.filter(
        (r) => String(r?.gubun ?? r?.GUBUN ?? r?.Gubun ?? '') === '1'
      );

      const maxLength = Math.max(list0.length, list1.length, 7);
      const tableData1 = [];
      for (let i = 0; i < maxLength; i++) {
        const r0 = list0[i] || {};
        const r1 = list1[i] || {};
        tableData1.push({
          depNm1: r0.DEP_NM || r0.depNm || '',
          name1: r0.NAME || r0.name || '',
          signature1: SignFileConvert(r0.FILE_PATH || r0.filePath) || '',
          depNm2: r1.CUST_NM || r1.custNm || '',
          name2: r1.NAME || r1.name || '',
          signature2: SignFileConvert(r1.FILE_PATH || r1.filePath) || '',
        });
      }
      const tableData2 = []; // (기존 리포트 포맷 유지용 - 현재 미사용)

      // 3) 회의안건: GetSubBasicMst03R2
      const search2Params = mapParamsBySchema(
        SUB_BASIC_03_Schema.mapper.search2,
        {
          search: { chaebun },
        }
      );
      const search2Result = await apiRequest(
        'post',
        Global.urls.SubcontractorManagement.getSubBasicMst03R2,
        search2Params
      );

      const agendaRowsRaw = search2Result?.data;
      const agendaRows = Array.isArray(agendaRowsRaw)
        ? agendaRowsRaw
        : agendaRowsRaw
          ? [agendaRowsRaw]
          : [];

      if (agendaRows[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: agendaRows[0]?.message || '인쇄할 데이터가 없습니다.',
            type: 'error',
          })
        );
        return;
      }

      const tableData3 = agendaRows
        .filter(
          (item) =>
            item?.AGENDA_NAME ||
            item?.agendaName ||
            item?.RESULT_DISCUSSION ||
            item?.resultDiscussion
        )
        .slice(0, 9)
        .map((item, index) => ({
          no: index + 1,
          agendaName: item.AGENDA_NAME || item.agendaName || '',
          resultDiscussion:
            item.RESULT_DISCUSSION || item.resultDiscussion || '',
        }));

      const printData = {
        FileName: 'SUB_BASIC_03',
        HeaderData: JSON.stringify(headerData),
        TableData1: JSON.stringify(tableData1),
        TableData2: JSON.stringify(tableData2),
        TableData3: JSON.stringify(
          tableData3.length
            ? tableData3
            : [{ no: '', agendaName: '', resultDiscussion: '' }]
        ),
      };

      const response = await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      );
      const blobUrl = URL.createObjectURL(response.data);
      window.open(blobUrl, '_blank');
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e?.message || '인쇄 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };

  // 파일 가져오는 함수
  function SignFileConvert(_filePath) {
    if (!_filePath) return null;

    const signUrl = `${Global.file.useUrl}files/${_filePath}`;
    let testSign = `data:image/png;base64,${signUrl}`;
    let sign1 = testSign.replace(
      /^data:image\/[a-z]+;base64,/, // 단위작업사진(접두사 없어야 됨)
      ''
    );

    return sign1 || '';
  }

  function ResetImage() {
    // 이미지 삭제 플래그 설정
    setInputs((prev) => ({
      ...prev,
      mapFile: '',
      filePath: '',
      fileName: '',
      saveName: '',
      newYn: 'Y',
      isImageDeleted: true, // 사진 삭제 플래그
    }));
    inputsRef.current = {
      ...inputsRef.current,
      mapFile: '',
      filePath: '',
      fileName: '',
      saveName: '',
      newYn: 'Y',
      isImageDeleted: true, // 사진 삭제 플래그
    };
    if (imgRef2.current) {
      imgRef2.current = null;
    }
  }
  //#endregion

  return (
    <SUB_BASIC_03
      navigate={navigate}
      userInfo={userInfo}
      dispatch={dispatch}
      showSnackbar={showSnackbar}
      inputs={inputs}
      setInputs={setInputs}
      inputsRef={inputsRef}
      imgRef2={imgRef2}
      currentChaebunRef={currentChaebunRef}
      gridRef1={gridRef1}
      gridRef5={gridRef5}
      gridRef8={gridRef8}
      rowData1={rowData1}
      setRowData1={setRowData1}
      selectedRowData1={selectedRowData1}
      setSelectedRowData1={setSelectedRowData1}
      changedRowData1={changedRowData1}
      setChangedRowData1={setChangedRowData1}
      modalToggle2={modalToggle2}
      setModalToggle2={setModalToggle2}
      modalRowData2={modalRowData2}
      setModalRowData2={setModalRowData2}
      attendeeData={attendeeData}
      setAttendeeData={setAttendeeData}
      modalToggle3={modalToggle3}
      setModalToggle3={setModalToggle3}
      modalToggle5={modalToggle5}
      setModalToggle5={setModalToggle5}
      modalToggle7={modalToggle7}
      setModalToggle7={setModalToggle7}
      modalRowData7={modalRowData7}
      setModalRowData7={setModalRowData7}
      selectedModalRowData7={selectedModalRowData7}
      setSelectedModalRowData7={setSelectedModalRowData7}
      meetingAgendaData={meetingAgendaData}
      setMeetingAgendaData={setMeetingAgendaData}
      searchKeyword={searchKeyword}
      setSearchKeyword={setSearchKeyword}
      searchResults={searchResults}
      setSearchResults={setSearchResults}
      selectedWorkers={selectedWorkers}
      setSelectedWorkers={setSelectedWorkers}
      validateSelection={props.validateSelection}
      dateValue={searchInfo}
      filterClick3={props.filterClick3}
      setFilterClick3={props.setFilterClick3}
      setDateValue={props.setDateValue}
      searchClick3={props.searchClick3}
      setSearchClick3={props.setSearchClick3}
      addClick3={props.addClick3}
      setAddClick3={props.setAddClick3}
      saveClick3={props.saveClick3}
      setSaveClick3={props.setSaveClick3}
      deleteClick3={props.deleteClick3}
      setDeleteClick3={props.setDeleteClick3}
      printClick3={props.printClick3}
      setPrintClick3={props.setPrintClick3}
      listClick3={props.listClick3}
      setListClick3={props.setListClick3}
      selectedRowNosRef={selectedRowNosRef}
      lastCheckedIndexRef={lastCheckedIndexRef}
      deletedRowData1={deletedRowData1}
      attendeeList={attendeeList}
      setAttendeeList={setAttendeeList}
      handleAttendeeSearch={handleAttendeeSearch}
      handleSearchWorkers={handleSearchWorkers}
      modalRowData3={modalRowData3}
      setModalRowData3={setModalRowData3}
      selectedModalRowData3={selectedModalRowData3}
      setSelectedModalRowData3={setSelectedModalRowData3}
      changedModalRowData3={changedModalRowData3}
      setChangedModalRowData3={setChangedModalRowData3}
      deletedModalRowData3={deletedModalRowData3}
      setDeletedModalRowData3={setDeletedModalRowData3}
      subcontractorList={subcontractorList}
      setSubcontractorList={setSubcontractorList}
      subcontractorAttendees={subcontractorAttendees}
      setSubcontractorAttendees={setSubcontractorAttendees}
      // 함수

      SignRequest={SignRequest}
      ResetImage={ResetImage}
      getCEOInfo={getCEOInfo}
      handleMeetingStart={handleMeetingStart}
      addMeetingAgenda={addMeetingAgenda}
      deleteMeetingAgenda={deleteMeetingAgenda}
      saveMeetingAgenda={save3}
      ResetLogic1={ResetLogic1}
      SearchLogic1={SearchLogic1}
      DeleteLogic1={DeleteLogic1}
      SaveLogic1={SaveLogic1}
      SaveLogic2={SaveLogic2}
      SaveLogic3={SaveLogic3}
      PrintLogic3={PrintLogic3}
      PopupClickEvent5={PopupClickEvent5}
      handleSubcontractorSearch={handleSubcontractorSearch}
      addSubcontractorAttendee={addSubcontractorAttendee}
      removeSubcontractor={removeSubcontractor}
      removeSubcontractorAttendee={removeSubcontractorAttendee}
      updateSubcontractorAttendee={updateSubcontractorAttendee}
      handleSubcontractorSelection={handleSubcontractorSelection}
      handleRowSelection={handleRowSelection}
      deleteHandler1={deleteHandler1}
      MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
      RestoreRow1={deleteHandler1.RestoreRow}
      DeleteNewRow1={deleteHandler1.DeleteNewRow}
      PopupClickEvent2Update={PopupClickEvent2Update}
      // 회의록 첨부파일
      ChangeMinutesFileLogic={ChangeMinutesFileLogic}
      RemoveMinutesFileLogic={RemoveMinutesFileLogic}
      DownloadMinutesFileLogic={DownloadMinutesFileLogic}
      // 로그관련 함수
      SCREEN_MENU_ID={SCREEN_MENU_ID}
      SaveActionLog={SaveActionLog}
    />
  );
}

export default SUB_BASIC_03F;
